<template lang="html">
    <div class="guarantee-detail preview">
        <MyTitle theTitle="保全详情"/>
        <div class="fd-com-scroll">
<!--        保全-执行信息预览 -->
            <app-preview-bq-zxxx></app-preview-bq-zxxx>
            <PerviewBasic/>
            <PerviewSQR/>
            <PerviewBSQR/>
            <PerviewYGDLR/>
            <PerviewCCXS v-if="cBqlx==='1'"/>
            <PreviewZJXX v-if="cBqlx==='2'"/>
            <PreviewXWXX v-if="cBqlx==='3'"/>
            <PreviewDBXX/>
            <PerviewSCCL/>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'
    import PerviewBasic from './previewPreservation/previewBasic'
    import PerviewSQR from './previewPreservation/previewSQR'
    import PerviewBSQR from './previewPreservation/previewBSQR'
    import PerviewYGDLR from './previewPreservation/previewYGDLR'
    import PerviewCCXS from './previewPreservation/previewCCXS'
    import PreviewXWXX from './previewPreservation/previewXWXX'
    import PreviewZJXX from './previewPreservation/previewZJXX'
    import PreviewDBXX from './previewPreservation/previewDBXX'
    import PerviewSCCL from './previewPreservation/previewSCCL';
    // 保全执行信息预览
    import appPreviewBqZxxx from './previewPreservation/zxxx/index.vue';

    export default {
        data() {
            return {
                active: 0,
                title: "和好",
                isShow: 2,
                cBqlx:'',
                // 路由中获取bqid
                bqid: this.$route.query.bqid,
                // 保全类别
                bqlb: this.$route.query.bqlb,
                // 担保情况
                dbqk: this.$route.query.dbqk
            }
        },
        // 依赖
        provide() {
            return {
                // 保全id
                bqid: this.bqid,
                // 保全类别
                bqlb: this.bqlb,
                // 担保情况
                dbqk: this.dbqk
            }
        },
        components: {
            MyTitle,
            PerviewBasic,
            PerviewSQR,
            PerviewBSQR,
            PerviewYGDLR,
            PerviewCCXS,
            PerviewSCCL,
            PreviewXWXX,
            PreviewDBXX,
            appPreviewBqZxxx,
            PreviewZJXX
        },
        methods: {
            //点击导航
            changeNav(navIndex) {
                this.active = navIndex
            }
        },
        created(){
            this.cBqlx=this.$route.query.bqlx;
        }
    }
</script>

<style lang="less" scoped>
    .guarantee-detail {
        .fd-nav {
            width: 100%;
            box-sizing: border-box;
            padding: 0 12px;
            display: flex;
            justify-content: space-between;
            line-height: 40px;
            background: #ffff;

            > span {
                font-size: 14px;
                color: #666666;
            }

            .span-active {
                color: #0683fc;
                cursor: pointer;
            }
        }
    }
</style>
